<app-info-message></app-info-message>
<div class="background--confirm">
  @if (!reset()) {
    <section class="form-container">
      <mat-toolbar>
        <mat-toolbar-row>
          <img src="../../assets/images/logo.svg" />
          <h5 class="toolbar-title">Online</h5>
        </mat-toolbar-row>
      </mat-toolbar>
      <div class="content-login">
        <div class="welcome-text">Please enter the username you used to register</div>
        <form [formGroup]="resetForm" (ngSubmit)="resetPassword()" (keydown.enter)="resetPassword()">
          <mat-form-field>
            <mat-label>Username</mat-label>
            <input autocomplete="username" formControlName="username" matInput required />
            @if (username.hasError('required')) {
              <mat-error> Username is <strong>required</strong> </mat-error>
            }
          </mat-form-field>
          <button
            matButton="elevated"
            type="submit"
            class="red-button body-1 mt-5"
            [disabled]="resetForm.invalid || submitPending()">
            REQUEST RESET LINK
          </button>
          <button matButton="text" type="button" class="body-1 mt-5" (click)="backToLogin()">BACK TO LOGIN</button>
        </form>
      </div>
    </section>
  }
  @if (reset()) {
    <section class="form-container">
      <mat-toolbar>
        <mat-toolbar-row>
          <img src="../../assets/images/logo.svg" />
          <h2 class="toolbar-title">online</h2>
        </mat-toolbar-row>
      </mat-toolbar>
      <div class="content-login">
        <div class="welcome-text" [class.reset]="reset()">
          <mat-icon>info_outline_24px</mat-icon>
          We’ve sent you an email with a link you can click to set a new password.
        </div>
      </div>
    </section>
  }
</div>
<app-static-footer />
